<section class="last-summary">
  @if (patDmrRelatedData && patDmrRelatedData.html !== "" && !isLoading) {
    <div class="container-text">
      @if (!isEditing) {
        <div style="width: 100%" [innerHTML]="patDmrRelatedData.html"></div>
      }
      @if (isEditing) {
        <textarea
          class="markdown-editor"
          [value]="markdownContent"
          (input)="onMarkdownChange($event)"
        ></textarea>
      }
    </div>
  }

  @if (
    (!patDmrRelatedData ||
      !patDmrRelatedData.html ||
      patDmrRelatedData.html === "") &&
    !isLoading
  ) {
    <div class="no-summary">
      <img
        src="assets/imgs/undraw/undraw_blank_canvas.svg"
        alt="Nessuna Scheda Clinica Dinamica"
      />
      <span
        >Non hai ancora generato la Scheda Clinica Dinamica, vai ad Analisi AI
        per generarla</span
      >
    </div>
  }

  @if (isLoading) {
    <div class="loading-container">
      <app-loader [size]="'big'"></app-loader>
    </div>
  }
</section>
